import React from 'react'
import PropTypes from 'prop-types'

const Search = ({ search, setSearchTerm, cy, size, disabled }) => {
  let sizeClass = ''
  if (size === 'lg') {
    sizeClass = 'form-control-lg'
  } else if (size === 'sm') {
    sizeClass = 'form-control-sm'
  }
  return (
    <div className='col form-group mb-0 position-relative'>
      <input
        className={`form-control mb-0 px-5 ${sizeClass}`}
        placeholder='Search'
        value={search}
        onChange={setSearchTerm}
        data-cy={cy}
        disabled={disabled}
      />
      <span className='fa-regular fa-magnifying-glass text-muted position-absolute search-icon' />
      {search && <span className='fa-regular fa-times pointer position-absolute search-x-icon' onClick={() => setSearchTerm({ target: { value: '' } })} />}
    </div>
  )
}

Search.propTypes = {
  search: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  cy: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool
}

export default Search
